import React, { useCallback } from 'react';
import { GroupContext, PREFERENCE_TYPE } from '@utils/userPreferencesUtils/Types';
import { buildProductNamespace, useProductAnalyzerGroupState } from '@utils/hook/userPreferences/UseGroupState';
import { useSharingConfig } from '@services/savedFilter/UseSharingConfig';
import { ShareGroupModal } from '@components/share-group-modal/ShareGroupModal';
import { useProductAnalyzerGroupEventState } from '@components/top-selling-products/product-table-grouping/utils/ProductAnalyzerGroupContext';
import { GeneralViewState } from '@models/SavedViews';
import { RetailerClient } from '@models/RetailerClient';

export interface Props {
  context: GroupContext;
  saveViewFilter: GeneralViewState;
  retailerClients: RetailerClient[];
}

export const ShareProductLeaderboardGroupModal: React.FC<Props> = ({ context, saveViewFilter, retailerClients }) => {
  const { groupNameToBeDelete, isShareModalGroupPopUp, setIsShareModalGroupPopUp } =
    useProductAnalyzerGroupEventState();

  const { addPreferencePermissionProductLeaderboardGroup } = useProductAnalyzerGroupState(context);

  const sharingConfig = useSharingConfig();
  const namespace = buildProductNamespace(context);
  const handleClose = useCallback(() => setIsShareModalGroupPopUp(false), [setIsShareModalGroupPopUp]);

  return (
    <ShareGroupModal
      isOpen={isShareModalGroupPopUp}
      itemToShare={groupNameToBeDelete}
      onClose={handleClose}
      onSuccess={handleClose}
      onShareError={handleClose}
      getUsers={sharingConfig.getUsersForGrouping}
      getShareUserGroups={sharingConfig.getUserGroupsForGrouping}
      namespace={namespace}
      selectedGroupingType={PREFERENCE_TYPE.productAnalysisGroup}
      addPreferencePermission={addPreferencePermissionProductLeaderboardGroup}
      saveViewFilter={saveViewFilter}
      retailerClients={retailerClients}
    />
  );
};
